var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "reset-data",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9365 12.1953C16.9365 12.1953 17.6502 11.8438 15.0615 11.8438C14.1344 11.8438 13.2281 12.1187 12.4573 12.6337C11.6864 13.1488 11.0856 13.8809 10.7308 14.7374C10.3761 15.594 10.2832 16.5365 10.4641 17.4457C10.645 18.355 11.0914 19.1903 11.747 19.8458C12.4025 20.5014 13.2378 20.9478 14.147 21.1287C15.0563 21.3095 15.9988 21.2167 16.8554 20.8619C17.7119 20.5071 18.444 19.9063 18.959 19.1355C19.4741 18.3646 19.749 17.4583 19.749 16.5312",
    stroke: "#FFFEFC",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0615 9.61719L17.4053 11.9609L15.0615 14.3047",
    stroke: "#FFFEFC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0615 4.63672C8.85059 4.63672 3.81152 9.67578 3.81152 15.8867C3.81152 22.0977 8.85059 27.1367 15.0615 27.1367C21.2725 27.1367 26.3115 22.0977 26.3115 15.8867C26.3115 9.67578 21.2725 4.63672 15.0615 4.63672Z",
    stroke: "#FFFEFC",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiRefresh);
export default __webpack_public_path__ + "static/media/ai-refresh.3f206210a92ffae3029b448498fb6a5c.svg";
export { ForwardRef as ReactComponent };